
































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { isEqual } from 'lodash'

@Component
export default class InputDate extends Vue {
    @Prop({ type: Boolean, default: false }) readonly notNullable!: boolean
    @Prop({ type: Boolean, default: true }) readonly trim!: boolean
    @Prop({ type: Boolean, default: false }) readonly labelOutside!: boolean
    @Prop({ default: null }) readonly rules!: string
    @Prop({ default: null }) readonly placeholder!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: string
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly clearable!: boolean
    internalValue: string = null

    created() {
        this.onExternalChange()
    }

    transformInput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    transformOutput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.transformInput(this.value)
        if (this.internalValue === null) {
            this.internalValue = ''
        }
    }

    @Watch('internalValue')
    onInternalChange() {
        if (this.notNullable === false && typeof this.internalValue === 'string' && this.internalValue.length === 0) {
            this.internalValue = null
        }

        const value = this.transformOutput(this.internalValue)
        if (!isEqual(this.value, value)) {
            this.$emit('input', value)
        }
    }

    onInput(): void {
        this.$emit('input', this.internalValue)
    }

    get componentClass(): object {
        return {
            'input-date': true,
            'bd-round-outline': true,
            'input-date--disabled': this.disabled,
        }
    }

    get isClearable(): boolean {
        return this.clearable && this.internalValue !== null && this.internalValue !== '' && !this.disabled
    }
}
